(function () {
  var COOKIE = "chb_mp_popup_done";
  var LIST_ID = "UrUQWA";
  var COMPANY = "SvTsSV";
  var force = /(?:\?|&)chb_force_popup=1(?:&|$)/.test(location.search);
  var blockedDomains = ["txt.att.net", "vtext.com", "tmomail.net", "messaging.sprintpcs.com", "msg.fi.google.com"];

  function klaviyoSubscribe(email, first, last, source) {
    var attributes = {
      email: email,
      subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
    };
    if (first) attributes.first_name = first;
    if (last) attributes.last_name = last;
    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: source,
          profile: { data: { type: "profile", attributes: attributes } }
        },
        relationships: { list: { data: { type: "list", id: LIST_ID } } }
      }
    };
    try {
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + COMPANY, {
        method: "POST",
        headers: { revision: "2025-10-15", "content-type": "application/vnd.api+json" },
        body: JSON.stringify(body),
        keepalive: true
      });
    } catch (e) {}
  }

  function bindNewsletter() {
    document.querySelectorAll("form.newsletter-form").forEach(function (form) {
      if (form.id === "chb-popup-form" || form.getAttribute("data-klaviyo-bound") === "1") return;
      form.setAttribute("data-klaviyo-bound", "1");
      form.addEventListener("submit", function () {
        var data = new FormData(form);
        var email = (data.get("contact[email]") || "").toString().trim();
        var domain = (email.split("@")[1] || "").toLowerCase();
        if (!email || email.indexOf("@") < 1 || blockedDomains.indexOf(domain) !== -1) return;
        klaviyoSubscribe(email, "", "", "Homepage newsletter");
      });
    });
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : "";
  }
  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 864e5);
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + date.toUTCString() + ";path=/;SameSite=Lax";
  }

  function boot() {
    bindNewsletter();
    var root = document.getElementById("chb-popup-root");
    if (!root) return;
    if (root.getAttribute("data-popup-blocked") === "1") return;
    if (window.Shopify && window.Shopify.designMode) return;
    var days = parseInt(root.getAttribute("data-days"), 10) || 14;
    var delay = parseInt(root.getAttribute("data-delay"), 10) || 4500;
    var form = document.getElementById("chb-popup-form");
    var msg = document.getElementById("chb-popup-msg");
    var panelForm = document.getElementById("chb-popup-panel-form");
    var panelOk = document.getElementById("chb-popup-panel-success");
    var posted = form && form.querySelector("[data-customer-posted]");
    var formError = form && form.querySelector(".chb-popup-msg.is-error");
    if (!force && getCookie(COOKIE) && !posted && !formError) return;
    var opened = false;

    function reveal() {
      if (opened) return;
      opened = true;
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      document.body.classList.add("chb-popup-lock");
    }
    function open() {
      if (opened || (!force && getCookie(COOKIE))) return;
      reveal();
      var email = form && form.querySelector("input[type='email']");
      if (email) setTimeout(function () { try { email.focus(); } catch (e) {} }, 280);
    }
    function close(mark) {
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
      document.body.classList.remove("chb-popup-lock");
      if (mark && !force) setCookie(COOKIE, "1", days);
    }
    function showJoined() {
      if (panelForm) panelForm.hidden = true;
      if (panelOk) panelOk.hidden = false;
      if (!force) setCookie(COOKIE, "1", days);
    }

    root.querySelectorAll("[data-chb-close]").forEach(function (el) {
      el.addEventListener("click", function () { close(true); });
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) close(true);
    });

    if (posted) {
      showJoined();
      reveal();
      return;
    }
    if (formError) reveal();

    setTimeout(open, force ? 400 : delay);

    var exitArmed = true;
    document.addEventListener("mouseout", function (event) {
      if (!exitArmed || opened || force) return;
      if (event.clientY <= 0) {
        exitArmed = false;
        open();
      }
    });

    if (!form) return;
    form.addEventListener("submit", function (event) {
      var data = new FormData(form);
      if ((data.get("website") || "").toString().trim()) {
        event.preventDefault();
        showJoined();
        return;
      }
      var email = (data.get("contact[email]") || "").toString().trim();
      var domain = (email.split("@")[1] || "").toLowerCase();
      if (!email || email.indexOf("@") < 1 || blockedDomains.indexOf(domain) !== -1) {
        event.preventDefault();
        if (msg) {
          msg.className = "chb-popup-msg is-error";
          msg.textContent = "Please enter a valid email address.";
        }
        return;
      }
      if (msg) {
        msg.className = "chb-popup-msg";
        msg.textContent = "";
      }
      klaviyoSubscribe(
        email,
        (data.get("contact[first_name]") || "").toString().trim(),
        (data.get("contact[last_name]") || "").toString().trim(),
        "Website popup"
      );
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
